import BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageSkeleton from "./ImageSkeleton";
import axios from "axios";

const NonResidential = () => {
  const [loading, setLoading] = useState(false);
  const [drawings, setDrawings] = useState([]);

  const runOnStart = async () => {
    setLoading(true);
    await axios
      .get(
        `${BASE_URL}/drawing/search-drawings/search?type=nonResidential`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` } }
      )
      .then((response) => setDrawings([...response.data.data]))
      .catch(() => {});
    setLoading(false);
  };

  useEffect(() => { runOnStart(); }, []);

  return (
    <div className="font-Montserrat min-h-screen bg-gray-50">
      {/* Spacer for fixed navbar */}
      <div className="h-[56px] md:h-[72px]" />

      {/* Page header */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4 md:px-10 py-10 md:py-16 text-center">
          <p className="text-[#1877F2] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-3">
            Commercial &amp; Industrial
          </p>
          <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3">
            Non-Residential Plans
          </h1>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            Professional architectural designs for offices, schools, warehouses,
            and other commercial structures.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-10 py-10 md:py-14">
        {loading ? (
          <ImageSkeleton />
        ) : drawings.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
            {drawings.map((drawing, index) => (
              <div
                key={index}
                className="rounded-xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 group bg-white flex flex-col"
              >
                <div className="overflow-hidden h-40 md:h-60">
                  <img
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    src={drawing.frontElevation}
                    alt={drawing.description || "Non-residential plan"}
                    loading="lazy"
                  />
                </div>
                <div className="p-3 md:p-4 flex flex-col flex-1 justify-between">
                  <div>
                    <p className="text-[10px] md:text-xs font-bold text-[#1877F2] mb-1 uppercase tracking-wide">
                      {drawing.refNo}
                    </p>
                    <p className="text-gray-800 text-xs md:text-sm font-medium line-clamp-2 leading-snug">
                      {drawing.description}
                    </p>
                  </div>
                  <Link to={`/house-details/${drawing._id}`} className="mt-3">
                    <button className="w-full py-1.5 md:py-2 rounded-full border border-[#1877F2] text-[#1877F2] text-[10px] md:text-sm font-semibold hover:bg-[#1877F2] hover:text-white transition-colors duration-200">
                      View Plan
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-24">
            <p className="text-4xl mb-4">🏢</p>
            <p className="text-gray-400 text-lg font-medium">No non-residential plans available yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NonResidential;
